import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@perxis-auto/ui-kit/lib/components/Button';

import { LinkProps } from './Link.types';

import styles from './Link.module.scss';

/**
 *  Компонент обёртка над Button, с возможностью использовать
 *  его как ссылку для внутреннего роутинга либо как якорную ссылку
 *  @param {string} to ссылка
 */
export default function Link({ to, ...props }: LinkProps) {
  return (
    <RouterLink to={to} className={styles.link}>
      <Button {...props} />
    </RouterLink>
  );
}
